'use client';

import { useEffect } from 'react';

export default function DevEnvClass() {
  useEffect(() => {
    const env = process.env.NEXT_PUBLIC_APP_ENV?.trim();
    const isProdOrDemo = env === 'production' || env === 'demo';
    if (!isProdOrDemo) {
      document.body.classList.add('dev-env');
    }
  }, []);

  return null;
}
